import React from "react";
import Form from "./form";
import LivePreview from "./live-preview";
import styles from './style';
import { withStyles } from '@material-ui/core';
import UserContext from 'context/UserContext';
import { getAssetCategoryId } from "relay/common"

var livePreview;
export default withStyles(styles)(React.memo(({ orgColors, ...props }) => {
  const { subOrgDetails } = React.useContext(UserContext);
  const [assetCategory, setAssetCategory] = React.useState();
  const [index, setIndex] = React.useState(12);

  React.useEffect(() => {
    getAssetCategoryId(subOrgDetails.id, "suborg_asset").then(id => {
      setAssetCategory(id)
    })
  }, [1])

  const setRef = (ref) => {
    livePreview = ref;
  }

  let property = {
    id: subOrgDetails.id,
    name: subOrgDetails.name,
    logo: subOrgDetails.propertyLogoUrl,
    orgLogo: subOrgDetails.propertyManagerLogoUrl
  }


  const updateLivePreview = (data) => {
    livePreview.update({ ...data, property, orgColors });
  }

  const onPropertyChange = (property) => {
    livePreview.update({ ...props.values, property, orgColors });
  }

  const handleIndexChange = (index) => {
    setIndex(index);
    livePreview.update({ ...props.values, property, orgColors });
  };

  return (
    <div className={props.classes.mainContainer} style={{ height: "calc(100vh - 150px)", overflow: "auto" }}>
      <Form {...props} assetCategory={assetCategory} onPropertyChange={onPropertyChange} onIndexChange={handleIndexChange} updateLivePreview={updateLivePreview} />
      <LivePreview ref={setRef}  {...props.values} property={property} index={index} orgColors={orgColors} />
    </div>
  )
}))